(() => {
  const init = () => {
    document.querySelectorAll('[data-bayu-cls-slider]').forEach(function (slider) {
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;
      var moved = false;

      slider.addEventListener('mousedown', function (e) {
        isDown = true;
        moved = false;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        slider.classList.add('bayu-cls__slider--dragging');
      });

      document.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - slider.offsetLeft;
        var walk = x - startX;
        if (Math.abs(walk) > 3) moved = true;
        slider.scrollLeft = scrollLeft - walk;
      });

      document.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        slider.classList.remove('bayu-cls__slider--dragging');
      });

      slider.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      slider.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function (e) {
          if (moved) {
            e.preventDefault();
            moved = false;
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})()